import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { humanizeRoleName } from '@core/utils/role-translation.util';

/**
 * Key prefixes whose last segment is a name delivered by the backend. A new backend feature
 * would otherwise show up as its raw translation key until nl.json and en.json catch up.
 */
const BACKEND_NAME_PREFIXES = ['roles.features.', 'roles.featureGroup.'];

/**
 * Shows a readable label instead of the raw key for a missing translation of a backend name.
 * Every other missing key is returned unchanged, because several screens detect a missing
 * translation by comparing the result with the key.
 */
export class ReadableFallbackMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    const { key } = params;
    const prefix = BACKEND_NAME_PREFIXES.find(candidate => key.startsWith(candidate));
    if (!prefix) {
      return key;
    }
    return humanizeRoleName(key.slice(prefix.length)) || key;
  }
}
